"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AirabbiUser = void 0;
var FirebaseApp_1 = require("../firebase/FirebaseApp");
var Future_1 = require("../../utils/Future");
var Utils_1 = require("../../utils/Utils");
var UserCache_1 = require("../UserCache");
var FirebaseUtils_1 = require("../firebase/FirebaseUtils");
var CoreServiceHelper_1 = require("./../provider/airabbi/CoreServiceHelper");
var AirabbiUser = (function () {
    function AirabbiUser(cfg) {
        var _this = this;
        this.cfg = cfg;
        this.log = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (_this.cfg.debuggable) {
                (_a = _this.cfg.logger).log.apply(_a, __spreadArray(["[".concat(_this.env, "] ").concat((0, Utils_1.getTimeString)(), " AirabbiUser#")], args, false));
            }
        };
        this.getAllUser = function () {
            _this.log('AirabbiUser#getAllUser <<<');
            var future = new Future_1.Future(Future_1.futureFunc);
            CoreServiceHelper_1.CoreServiceHelper.getHelper(_this.cfg)
                .queryData('Users', {}, {}, {}, '')
                .then(function (res) {
                var tmps = res && res.result ? res.result : [];
                var users = [];
                tmps.forEach(function (tmp) {
                    var obj = AirabbiUser.CONVERT(tmp);
                    if (obj) {
                        users.push(obj);
                    }
                    return false;
                });
                future.resolve(users);
            })
                .catch(function (err) {
                _this.log("AirabbiUser#getAllUser, error", err);
                future.reject(err);
            });
            return future.promise;
        };
        this.getAllUnits = function () {
            var future = new Future_1.Future(Future_1.futureFunc);
            CoreServiceHelper_1.CoreServiceHelper.getHelper(_this.cfg)
                .queryData('Users', {}, {}, {}, 'unit')
                .then(function (res) { return future.resolve(res && res.result ? res.result : []); })
                .catch(function (err) { return future.reject(err); });
            return future.promise;
        };
        this.getAllUsersByUnit = function () {
            var currentUser = (0, UserCache_1.loadUser)();
            _this.log('AirabbiUser#getAllUsersByUnit <<<');
            if (!currentUser.unit) {
                return Promise.reject('unit cannot be empty!');
            }
            var future = new Future_1.Future(Future_1.futureFunc);
            CoreServiceHelper_1.CoreServiceHelper.getHelper(_this.cfg)
                .queryData('Users', { unit: currentUser.unit }, {}, {}, '')
                .then(function (res) {
                var tmps = res && res.result ? res.result : [];
                var users = [];
                tmps.forEach(function (tmp) {
                    var obj = AirabbiUser.CONVERT(tmp);
                    if (obj) {
                        users.push(obj);
                    }
                    return false;
                });
                future.resolve(users);
            })
                .catch(function (err) {
                _this.log("AirabbiUser#getAllUsersByUnit, error", err);
                future.reject(err);
            });
            return future.promise;
        };
        this.getUsersByRole = function (role) {
            var currentUser = (0, UserCache_1.loadUser)();
            _this.log('AirabbiUser#getUsersByRole <<<');
            if (!currentUser.unit) {
                return Promise.reject('unit cannot be empty!');
            }
            var future = new Future_1.Future(Future_1.futureFunc);
            CoreServiceHelper_1.CoreServiceHelper.getHelper(_this.cfg)
                .queryData('Users', { unit: currentUser.unit, role: role }, {}, {}, '')
                .then(function (res) {
                var tmps = res && res.result ? res.result : [];
                var users = [];
                tmps.forEach(function (tmp) {
                    var obj = AirabbiUser.CONVERT(tmp);
                    if (obj) {
                        users.push(obj);
                    }
                    return false;
                });
                future.resolve(users);
            })
                .catch(function (err) {
                _this.log("AirabbiUser#getUsersByRole, error", err);
                future.reject(err);
            });
            return future.promise;
        };
        this.getUser = function (uid) {
            var future = new Future_1.Future(Future_1.futureFunc);
            CoreServiceHelper_1.CoreServiceHelper.getHelper(_this.cfg)
                .queryOne('Users', { uid: uid }, {})
                .then(function (res) {
                var user = res ? res.result : undefined;
                future.resolve(user);
            })
                .catch(function (err) {
                _this.log("getUser, error", err);
                future.reject(err);
            });
            return future.promise;
        };
        this.createNewUser = function (user) {
            if (!user || !user.uid || user.uid === '') {
                return Promise.reject('createNewUser error, incorrect user!');
            }
            _this.log('createNewUser, user:', user);
            var future = new Future_1.Future(Future_1.futureFunc);
            var userInDB = Object.assign({}, user);
            delete userInDB.password;
            if (!('created' in userInDB)) {
                userInDB.created = Date.now();
            }
            _this.mergeUnits(user);
            CoreServiceHelper_1.CoreServiceHelper.getHelper(_this.cfg)
                .patchData('Users', { uid: (0, Utils_1.email2UID)(user.email, '-') }, userInDB)
                .then(function () {
                FirebaseApp_1.FirebaseApp.GET()
                    .firebase.database()
                    .ref("usersnew/".concat((0, Utils_1.email2UID)(user.email, '-')))
                    .update(user)
                    .then(function () {
                    future.resolve();
                })
                    .catch(function (error) {
                    _this.log('createNewUser, update usersnew/ error!', error);
                    future.reject(error);
                });
            })
                .catch(function (err) {
                _this.log('createNewUser, update users/ error!', err);
                future.reject(err);
            });
            return future.promise;
        };
        this.createUser = function (user) {
            if (!user || !user.uid || user.uid === '' || !user.email || user.email === '') {
                return Promise.reject('createUser# cannot create user, data is invalid!');
            }
            user.uid = user.uid.toLowerCase();
            user.email = user.email.toLowerCase();
            if (user.moreInfo &&
                user.moreInfo.gender &&
                (user.moreInfo.gender.indexOf('女') !== -1 || user.moreInfo.gender.indexOf('female') !== -1)) {
                user.moreInfo.gender = 'female';
            }
            else {
                if (user.moreInfo) {
                    user.moreInfo.gender = 'male';
                }
            }
            _this.log('createUser#, user:', user.uid);
            var future = new Future_1.Future(Future_1.futureFunc);
            _this.getUser(user.uid)
                .then(function (u) {
                if (!u || !u.uid || !u.email) {
                    _this.createNewUser(user)
                        .then(function () {
                        _this.log('createUser#, user:', "User(".concat(user.uid, ") created successfully! Type I"));
                        future.resolve();
                    })
                        .catch(function (err) { return future.reject(err); });
                }
                else {
                    var newUser_1 = Object.assign(u, user);
                    delete newUser_1.password;
                    _this.updateUser(newUser_1)
                        .then(function () {
                        _this.log('createUser#, update existed user:', "User(".concat(newUser_1.uid, ") update successfully! Type I"));
                        future.resolve();
                    })
                        .catch(function (err) { return future.reject(err); });
                }
            })
                .catch(function (err) {
                _this.log('createUser#, user:', "getUser err(".concat(err, "), to createNewUser, User{").concat(user.uid));
                _this.createNewUser(user)
                    .then(function () {
                    _this.log('createNewUser#, user:', "User(".concat(user.uid, ") created successfully! Type II"));
                    future.resolve();
                })
                    .catch(function (err2) {
                    _this.log("createNewUser# User(".concat(user.uid, ")"), err2);
                    future.reject(err2);
                });
            });
            return future.promise;
        };
        this.updateUser = function (user) {
            if (!user || !user.email || user.email === '') {
                return Promise.reject('!Unknown user!');
            }
            _this.mergeUnits(user);
            var future = new Future_1.Future(Future_1.futureFunc);
            CoreServiceHelper_1.CoreServiceHelper.getHelper(_this.cfg)
                .updateData('Users', { uid: (0, Utils_1.email2UID)(user.email, '-') }, user)
                .then(function () {
                var localUser = (0, UserCache_1.loadUser)();
                if (localUser && localUser.uid === user.uid) {
                    (0, UserCache_1.updateUser)(user);
                }
                future.resolve();
            })
                .catch(function (err) { return future.reject(err); });
            return future.promise;
        };
        this.removeUser = function (user) {
            if (!user || !user.email || user.email === '') {
                return Promise.reject('!Unknown user!');
            }
            var uid = (0, Utils_1.email2UID)(user.email, '-');
            return CoreServiceHelper_1.CoreServiceHelper.getHelper(_this.cfg)
                .removeData('Users', { uid: uid })
                .then(function () {
                return (0, FirebaseUtils_1.setNode)("deleteUsers/".concat(uid), user);
            });
        };
        this.log('created!');
    }
    AirabbiUser.prototype.init = function (env) {
        this.env = env;
    };
    AirabbiUser.CONVERT = function (user) {
        if (!user) {
            return undefined;
        }
        return {
            uid: user.uid,
            email: user.email,
            emailVerified: user.emailVerified ? user.emailVerified : false,
            token: user.token ? user.token : '',
            role: user.role ? user.role : 'unknown',
            displayName: user.displayName,
            phoneNumber: user.phoneNumber ? user.phoneNumber : '',
            photoUrl: user.photoURL
                ? user.photoURL
                : user.photoUrl
                    ? user.photoUrl
                    : 'https://lh5.googleusercontent.com/-ZDjTW6LDn6Y/AAAAAAAAAAI/AAAAAAAAjDc/cMF3Veygbm0/photo.jpg',
            updated: user.updated ? user.updated : Date.now(),
            isIntern: user.isIntern ? user.isIntern : false,
            isUsingApp: user.isUsingApp === true ? true : false,
            firstName: user.firstName ? user.firstName : '',
            lastName: user.lastName ? user.lastName : '',
            nickName: user.nickName ? user.nickName : '',
            moreInfo: user.moreInfo ? user.moreInfo : '',
            units: user.units ? user.units : [],
            unit: user.unit ? user.unit : '',
            creator: user.creator ? user.creator : '',
            isEmailVerified: user.isEmailVerified ? user.isEmailVerified : false,
            providerId: user.providerId ? user.providerId : 'unknown'
        };
    };
    AirabbiUser.prototype.mergeUnits = function (user) {
        if (!user.unit) {
            return;
        }
        if (!user.units) {
            user.units = [user.unit];
        }
        if (!user.units.find(function (u) { return u === user.unit; })) {
            user.units.push(user.unit);
        }
    };
    return AirabbiUser;
}());
exports.AirabbiUser = AirabbiUser;
//# sourceMappingURL=AirabbiUser.js.map